import { ContractTypeValue } from './leasing-section.props';

export const LEASING_CONTRACT_LABEL_MAPPING = {
  [ContractTypeValue.AccidentPreventionRegulation]: '',
  [ContractTypeValue.FinancialRate]: 'Finanzrate',
  [ContractTypeValue.Insurance]: 'Versicherung',
  [ContractTypeValue.TireReplacement]: 'Reifenersatz',
  [ContractTypeValue.WinterWheels]: 'Winterräder'
};
